
// Variables
const blocks = document.querySelectorAll(".related-tabbed-team-members")

// Initializing Splider
for (let i = 0; i < blocks.length; i++) {
    const block = blocks[i]
    const tabsWrapper = block.querySelector('.tabs')
    const tabs = block.querySelectorAll('.tab')
    const tabButtons = block.querySelectorAll('.tab-buttons button')
    let timeoutId;

    tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            if(!button.classList.contains('active')) {
                const tabId = button.getAttribute('aria-controls');
                const targetTab = block.querySelector(`#${tabId}`);

                // Clear any existing timeout to prevent overlapping animations
                clearTimeout(timeoutId);

                // Fade out the tabsWrapper
                tabsWrapper.style.opacity = 0;

                timeoutId = setTimeout(() => {
                    // Remove 'active' class and update aria attributes for all tabs and tabButtons
                    tabs.forEach(tab => {
                        tab.classList.remove('active');
                        tab.setAttribute('aria-hidden', 'true');
                    });
                    tabButtons.forEach(btn => {
                        btn.classList.remove('active');
                        btn.setAttribute('aria-expanded', 'false');
                    });

                    // Add 'active' class and update aria attributes for the clicked tabButton and target tab
                    button.classList.add('active');
                    button.setAttribute('aria-expanded', 'true');
                    targetTab.classList.add('active');
                    targetTab.setAttribute('aria-hidden', 'false');

                    // Fade in the tabsWrapper
                    tabsWrapper.style.opacity = 1;
                }, 300); // Adjust timeout duration to match fade-out animation
            }
        });

        // Add keyboard accessibility for arrow keys
        button.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
                const nextIndex = (index + 1) % tabButtons.length;
                tabButtons[nextIndex].focus();
            } else if (event.key === 'ArrowLeft') {
                const prevIndex = (index - 1 + tabButtons.length) % tabButtons.length;
                tabButtons[prevIndex].focus();
            } else if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                button.click();
            }
        });
    });
}